// @ts-strict-ignore
import React from 'react'
import { RichText } from '@uswitch/ev-core/react'
import { Card } from '../../atoms'
import { removeWhitespaceAndSpecialChars } from '@h/commons'

const Chart = (props) => {
  const { title, contents, footnotes, chartConfig, name } = props

  const transposedContents = contents.map((_, colIndex) =>
    contents.map((_, rowIndex) => contents[rowIndex][colIndex]?.value),
  )

  const santisedArr = transposedContents
    .map((item) => item.filter((it) => !!it))
    .filter((arr) => arr.length > 0)

  const labels = santisedArr[0].slice(1)
  const datasets = santisedArr.slice(1)

  return (
    <div className='chart' id={removeWhitespaceAndSpecialChars(name)}>
      <Card variant={'modal'}>
        {title && <div className='chart__heading'>{title}</div>}
        {chartConfig.subHeading && (
          <div className='chart__sub-heading'>{chartConfig.subHeading}</div>
        )}
        <div
          className='chart__container'
          data-controller='chart'
          data-chart-labels-value={JSON.stringify(labels)}
          data-chart-dataset-value={JSON.stringify(datasets)}
          data-chart-config-value={JSON.stringify(chartConfig)}
        >
          <canvas data-chart-target='canvas' id='myChart' height='405'></canvas>
        </div>
        {footnotes && (
          <div className='chart__footnotes'>
            <RichText content={footnotes} />
          </div>
        )}
      </Card>
    </div>
  )
}

export default Chart
